<template>
  <div id="header">
    <div class="header-box">
      <router-link to="/" class="logo">
        <img src="../assets/images/logo.png" />
      </router-link>
      <div class="nav-box">
        <ul>
          <li
            v-for="(item, index) in languagesData['nav']"
            @click="mainChoose(item.name)"
            :class="
              $store.state.highlight == item.name ? 'head-li active' : 'head-li'
            "
            :key="index"
          >
            <router-link v-if="item" :to="item.url">
              {{ item.title }}
            </router-link>
          </li>
          <li>
            <a href="https://webpay.zenifun.com" target="_blank">
              <div class="my-card">
                <div class="my-card-text">官網儲值</div>
                <div class="my-card-num">額外反饋&nbsp;5%</div>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState(["languages", "languagesData"]), // 在这里引入你需要的state值
  },
  methods: {
    mainChoose(type) {
      console.log("type", type);
      // this.heiAct = type;
      this.$store.state.highlight = type;
    },
  },
  mounted() {
    this.$store.state.highlight = this.$route.name;
    this.language = this.$store.state.languages;
    console.log("language", this.language);
  },
};
</script>
<style scoped>
body {
    -webkit-text-size-adjust: none !important;
}

#header {
  width: 100%;
}

.header-box {
  width: 100%;
  height: 84px;
  min-width: 1200px;
  text-align: center;
  margin: 0 auto;
  position: fixed;
  left: 0;
  right: 0;
  z-index: 3;
  background-color: rgba(0, 0, 0, 0.6);
}

.logo {
  height: 129px;
  vertical-align: middle;
}

.logo img {
  height: 100%;
}

.nav-box {
  font-size: 0;
  display: inline-block;
  vertical-align: middle;
}

.nav-box li {
  display: inline-block;
  font-size: 27px;
  line-height: 84px;
  cursor: pointer;
  font-weight: 700;
  margin-left: 117px;
  color: #a3a3a3;
}

.nav-box li a {
  font-size: 25px;
  color: #a3a3a3;
  display: block;
}

.nav-box li.active a {
  color: white;
}

.nav-box li span {
  display: inline-block;
  margin: 0 5px;
  color: #a3a3a3;
}

.nav-box li span.active {
  color: white;
}

.my-card {
  line-height: 0%;
  position: relative;
  top: -2px;
}

.my-card-text {
  color: #a3a3a3;
}

.my-card-num {
  position: relative;
  top: 27px;
  font-size: 15px;
  left: 4px;
  color: rgb(246, 179, 92);
}

@media screen and (max-width: 1000px) {
  #header {
    max-width: 750px;
  }

  .header-box {
    max-width: 750px;
    min-width: auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0;
  }

  .logo {
    height: 58px;
  }

  .nav-box {
    width: 100%;
    /* background-color: aqua; */
    font-size: 0;
  }
  .nav-box ul {
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .nav-box li {
    font-size: 1.5rem;
    /* font-size: 25px; */
    cursor: pointer;
    font-weight: 0;
    margin-left: 0px;
    color: #a3a3a3;
    text-align: center;
  }

  .nav-box li a {
    font-size: 1rem !important;
    zoom: 1.3 !important;
  }

  .my-card {
    top: 1px;
  }

  .my-card-text {
    font-size: 1rem !important;
    zoom: 1 !important;
    font-size: 22px;
  }

  .my-card-num {
    /* font-size: 12px; */
    font-size: 1rem !important;
    zoom: 0.6 !important;
    top: 30px;
    left: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue